import { ShippingLineItem } from '../DeShippingTableWrapper';

export interface LineItemUpdate {
  workflow_id: number;
  line_item_id: string;
  fulfillment_status: string;
  fulfillment_location: string;
  decline_reason: string;
}

export interface LineItemChanges {
    [lineItemId: string]: {
      fulfillment_status?: string;
      fulfillment_location?: string;
      decline_reason?: string;
    };
  }


export interface BulkUpdatePayload {
  order_id: string;
  line_item_updates: LineItemUpdate[];
}

export const transformLineItemChangesToApiFormat = (
    lineItemChanges: LineItemChanges,
    lineItems: ShippingLineItem[],
    orderId: string
  ): BulkUpdatePayload => {
    console.log('lineItemChanges', lineItemChanges);
    const lineItemUpdates: LineItemUpdate[] = [];
  
    // Create a map for quick lookup of line items by ID
    const lineItemMap = new Map(
    lineItems.map(item => [item.line_item_id.toString(), item])
    );
    console.log('lineItemMap', lineItemMap);
  
    // Transform each changed line item
    Object.entries(lineItemChanges).forEach(([lineItemIdStr, changes]) => {
      // Keep as string, don't parse to int
      const lineItem = lineItemMap.get(lineItemIdStr);
  
      if (!lineItem) {
        console.warn(`Line item with ID ${lineItemIdStr} not found in current line items`);
        return;
      }
  
      // Only include if there are actual changes
      if (Object.keys(changes).length > 0) {
        lineItemUpdates.push({
          workflow_id: lineItem.workflow_id,
          line_item_id: lineItemIdStr, // Use string directly
          fulfillment_status: changes.fulfillment_status || lineItem.fulfillment_status,
          fulfillment_location: changes.fulfillment_location || lineItem.fulfillment_location || '',
          decline_reason: changes.decline_reason || lineItem.decline_reason || ''
        });
      }
    });
  
    return {
      order_id: orderId,
      line_item_updates: lineItemUpdates
    };
  };